export const CREATE_STRIPE_ACCOUNT_START = 'CREATE_STRIPE_ACCOUNT_START';
export const CREATE_STRIPE_ACCOUNT_SUCCESS = 'CREATE_STRIPE_ACCOUNT_SUCCESS';
export const CREATE_STRIPE_ACCOUNT_FAILED = 'CREATE_STRIPE_ACCOUNT_FAILED';

export const CREATE_STRIPE_BY_AFFILIATE_START = 'CREATE_STRIPE_BY_AFFILIATE_START';
export const CREATE_STRIPE_BY_AFFILIATE_SUCCESS = 'CREATE_STRIPE_BY_AFFILIATE_SUCCESS';
export const CREATE_STRIPE_BY_AFFILIATE_FAILED = 'CREATE_STRIPE_BY_AFFILIATE_FAILED';

export const createStripeAccountStart = () => ({
  type: CREATE_STRIPE_ACCOUNT_START
});

export const createStripeAccountSuccess = (data) => ({
  type: CREATE_STRIPE_ACCOUNT_SUCCESS,
  data
});

export const createStripeAccountFailed = (error) => ({
  type: CREATE_STRIPE_ACCOUNT_FAILED,
  error
});

export const createStripeByAffiliateStart = () => ({
  type: CREATE_STRIPE_BY_AFFILIATE_START
});

export const createStripeByAffiliateSuccess = (data) => ({
  type: CREATE_STRIPE_BY_AFFILIATE_SUCCESS,
  data
});

export const createStripeByAffiliateFailed = (error) => ({
  type: CREATE_STRIPE_BY_AFFILIATE_FAILED,
  error
});
